<rask-container-block [noBorder]="true" class="list-block">
    <rask-header class="flex" size="2">
        {{isSkogsvardFPV ? "Skogsvårdsuppdrag" : "Kontrakt"}}

        <ng-container
            *raskPermitted="[{ role: 'RASK.Kopplanera', canEdit: false }]; hide: false; merge: true; let edit = canEdit">
            @if (!isSkogsvardFPV) {
            <rask-action-button [disabled]="!edit"
                icon=" fas fa-plus"
                (click)="clickCreateSkogsvardsKontrakt()"
                aid="buttonCreateSkogsvardsKontrakt">
                Lägg till skogsvårdskontrakt
            </rask-action-button>
            }
            @if (isSkogsvardFPV) {
            <rask-action-button [disabled]="!edit"
                icon=" fas fa-plus"
                (click)="clickCreateSkogsvardsKontrakt()"
                aid="buttonCreateSkogsvardsKontrakt">
                Lägg till Skogsvårdsuppdrag
            </rask-action-button>
            }
            @if (!isSkogsvardFPV) {
            <rask-action-button [disabled]="!edit"
                icon="fas fa-plus"
                (click)="clickCreateKontrakt()"
                aid="buttonCreateKontrakt">
                Lägg till nytt anbud eller kontrakt
            </rask-action-button>
            }
        </ng-container>
    </rask-header>
    @if (kontrakt?.length > 0) {
    <div>
        <rask-tabs
            layout="parent"
            parameterName="kontraktId"
            [useRoute]="true"
            [selectedTabId]="selectedTabId$ | async"
            [autoSelectNewTab]="true"
            [updateRouteOnLoad]="true"
            aid="kontrakts"
            [wrap]="true"
            class="fill-tab-headers">
            @for (k of kontrakt; track trackById($index, k)) {
            <rask-tab #tab
                [label]="getTabName(k)"
                [routeId]="$safeNavigationMigration(k.id?.toString())"
                [icon]="getIcon(k)"
                [ignoreIconClick]="true"
                (onTabSelected)="tabSelected(k)">
                @if (tab.visited) {
                <rask-kontrakt-item
                    [entity]="k"
                    [tabState]="tab.state$ | async"
                    (loading)="loaded($event, tab)">
                </rask-kontrakt-item>
                }
            </rask-tab>
            }
        </rask-tabs>
    </div>
    }
</rask-container-block>